import React from "react";
import {
  Box,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "../../../assets/icons/search-icon.png";
import GlobalButton from "../../../components/button";
import CustomRangePicker from "../../../components/dateRange";
import PackagesMenu from "./AllPackages";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CustomDropDown from "../../../components/select";
import { useDispatch, useSelector } from "react-redux";
import {
  setLeadEndDate,
  setLeadSaleStatusValue,
  setLeadSearchValue,
  setLeadStartDate,
} from "../../../lib/redux/slices/searchKeysSlice";
import { setCurrentPage } from "../../../lib/redux/slices/contractPaginateSlice";

const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    backgroundColor: "#ffffff",
    fontSize: "0.875rem",
    "& .MuiOutlinedInput-input": {
      padding: "8px 8px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #E99509`,
      borderColor: "primary.main",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #E99509`,
      borderColor: "primary.main",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #E99509`,
      borderColor: "primary.main",
    },
  },
};

const SaleStatus = [
  "Lead",
  "Contract Sent",
  "Sale",
  "Provisioning",
  "Live",
  "Future Live",
  "Delayed Live",
  "Rework",
  "Winback",
  "Cancel Pre-Live - In Contract",
  "Cancel Pre-Live - Better price",
  "Cancel Pre-Live - Change of mind or Not interested",
  "Cancel Pre-Live - No reason disclosed",
  "Cancel Pre Live - Incorrect Product Sold",
  "Cancel Pre-Live - Incompatible product",
  "Duplicate lead",
  "Test",
];

const SearchTab = ({ allContracts, onFilterDate, handleReset }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

  return (
    <Stack
      mt={4}
      mb={2}
      px={1}
      py={2}
      gap={2}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      bgcolor="primary.light"
      flexWrap="wrap"
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        flex={1}
        flexWrap={"wrap"}
      >
        <Typography variant="body2" fontSize="0.75rem" color="secondary.dark">
          connections ({allContracts?.length})
        </Typography>
        <Box width={{ xs: "100%", sm: 400 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search..."
            sx={textFieldStyles}
            value={searchKeys?.leadSearchValue}
            onChange={(e) => dispatch(setLeadSearchValue(e.target.value))}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={SearchIcon} width={16} alt="Search" />
                </InputAdornment>
              ),
              ...(searchKeys?.leadSearchValue && {
                endAdornment: (
                  <InputAdornment position="end">
                    <CancelOutlinedIcon
                      fontSize="small"
                      onClick={() => dispatch(setLeadSearchValue(""))}
                      sx={{ cursor: "pointer" }}
                    />
                  </InputAdornment>
                ),
              }),
            }}
          />
        </Box>
        <Box width={{ xs: "100%", sm: 250 }}>
          <CustomDropDown
            size={"small"}
            variant="outlined"
            stylePropos={textFieldStyles}
            icon={<img src={SearchIcon} width={16} alt="Search" />}
            value={searchKeys?.leadSaleStatusValue}
            onChange={(e) => {
              dispatch(setCurrentPage(1));
              dispatch(setLeadSaleStatusValue(e.target.value));
            }}
            multiple
          >
            {SaleStatus.map((val, index) => {
              return (
                <MenuItem key={index} value={val}>
                  {val}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Box>
        {/* <PackagesMenu />*/}
        <CustomRangePicker
          startDate={searchKeys?.leadStartDate}
          endDate={searchKeys?.leadEndDate}
          setStartDate={(start) => dispatch(setLeadStartDate(start))}
          setEndDate={(end) => dispatch(setLeadEndDate(end))}
          handleFilterDate={onFilterDate}
          stackProps={{
            boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
            borderRadius: "6px",
            padding: "2px 8px",
            border: "1px solid",
            borderColor: "primary.main",
          }}
        />
        {/* <GlobalButton
        variant="custom_gradient"
        title="Add Lead"
        startIcon={<AddIcon />}
        handleClickBtn={() => navigate("/add-lead")}
        style={{
          width: { xs: "100%", sm: 130 },
          borderRadius: "100px",
          }}
      /> */}
        <GlobalButton
          title={"Reset"}
          handleClickBtn={handleReset}
          style={{ width: "auto", padding: "5px" }}
        />
      </Stack>
    </Stack>
  );
};

export default SearchTab;
